// Coach Studio safe recorder (Gate-2). A module-level singleton so a recording
// survives route changes (the Studio page unmounts while the author demonstrates
// the workflow). Captures ONLY safe signals: route changes and interactions with
// elements tagged `data-coach-target`. NEVER captures DOM text, values, or any
// business data.
let active = false;
let goal = '';
let buffer = [];
let lastRoute = '';
let intervalId = null;
const subs = new Set();

function notify() { subs.forEach((f) => f({ active, count: buffer.length, goal })); }

export function subscribeRecorder(fn) { subs.add(fn); fn({ active, count: buffer.length, goal }); return () => subs.delete(fn); }
export function isRecording() { return active; }
export function getGoal() { return goal; }

function pushRouteIfChanged() {
  const r = window.location.pathname;
  if (r !== lastRoute) {
    lastRoute = r;
    buffer.push({ event_type: 'route_entered', semantic_target_id: null, route: r });
    notify();
  }
}

function onClickCapture(e) {
  const el = e.target.closest && e.target.closest('[data-coach-target]');
  pushRouteIfChanged();
  if (el) {
    buffer.push({
      event_type: 'target_interaction',
      semantic_target_id: el.getAttribute('data-coach-target'),
      route: window.location.pathname,
    });
    notify();
    return;
  }
  // Record-to-discover: also capture clicks on controls that carry a stable
  // data-testid but aren't Coach targets yet, so admins can promote them later.
  // Only the testid (a dev hook) + route are captured — never DOM text or data.
  const tided = e.target.closest && e.target.closest('[data-testid]');
  if (tided) {
    buffer.push({
      event_type: 'target_candidate',
      semantic_target_id: tided.getAttribute('data-testid'),
      route: window.location.pathname,
    });
    notify();
  }
}

export function startRecording(g) {
  active = true;
  goal = g || '';
  buffer = [];
  lastRoute = '';
  pushRouteIfChanged();
  document.addEventListener('click', onClickCapture, true);
  intervalId = setInterval(pushRouteIfChanged, 600);
  notify();
}

export function stopRecording() {
  active = false;
  document.removeEventListener('click', onClickCapture, true);
  if (intervalId) { clearInterval(intervalId); intervalId = null; }
  const out = { goal, steps: buffer.slice() };
  notify();
  return out;
}
